"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _SttButton = _interopRequireDefault(require("./SttButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttSearchButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    type: props.type || "submit",
    variant: props.variant || "contained",
    color: props.color || "primary",
    onClick: props.onClick || null,
    startIcon: /*#__PURE__*/_react["default"].createElement(_Search["default"], null),
    disabled: props.disabled,
    nomarginleft: props.nomarginleft || "true",
    className: props.className || undefined
  }, props.children || "Pesquisar");
}
var _default = SttSearchButton;
exports["default"] = _default;